import $ from 'jquery';


const search = function (options) {
    let o, internal, elements, fn;


    o = $.extend({
        $e: null,
        selector: ''
    }, options);


    internal = {
        $e: o.$e || $(o.selector)
    };


    elements = {
        input: internal.$e.find('input[type="text"]')
    };


    fn = {
        init () {
            if (elements.input.length > 0) {
                const searchVal = elements.input.val();

                elements.input.focus();

                // move cursor to end of text
                if (searchVal) {
                    elements.input.val('').val(searchVal);
                }
            }
        }
    };


    fn.init();
};


search.markup = {
    // dom selector
    CONTAINER: 'search'
};


export default search;



// WEBPACK FOOTER //
// ./assets/js/components/search.js